// extracted by mini-css-extract-plugin
module.exports = {"layout":"HomePage_layout__sze7k"};